/* tu-loader.js -- sequenced loading below the fold (perf plan A17, 2026-09-14).
 * Order: hero load -> the reviews rail's four players (tu:reviews-ready,
 * fired by tu-video.js) -> every [data-tu-band], one band at a time, always
 * the band nearest the viewport next. Re-sorted on scroll, so a visitor who
 * jumps to Merch gets Merch next. A band that has not finished in 2 s does
 * not hold the queue. Without JS nothing below the reviews rail loads --
 * acceptable: Googlebot renders JS, and no-JS visitors are not a measured
 * audience here (see the plan's own "Risk" note).
 *
 * Hero signal (build order decided 2026-09-14: A0/A1/A17 ship before A5, so
 * the hero is still a CSS background, not a real <img>): read the painted
 * main tile's background-image URL off [data-tu-hero] and probe it with a
 * bare Image(). tu-hero-mosaic.liquid preloads the same URL with
 * fetchpriority="high", so by the time this probe's request goes out it
 * almost always resolves straight from that fetch rather than opening a
 * second one. tu-video.js uses the identical probe for its own heroDone.
 */
(function () {
  var bands = Array.prototype.slice.call(document.querySelectorAll('[data-tu-band]'));
  if (!bands.length) return;
  var pending = bands.slice(), running = false, started = false;
  function distance(el) { var r = el.getBoundingClientRect(); return r.bottom < 0 ? -r.bottom : Math.max(0, r.top - window.innerHeight); }
  // 2026-10-06 (hero speed, load order): one place that swaps a deferred image in and says when it has arrived.
  // data-tu-src (photos; also the small hero tiles, filled right after the main hero) and data-tu-logo-src (brand strip logos,
  // which have their own bar + fade, so no is-loaded / shimmer classes). Resolves on load or error.
  function fill(img) {
    return new Promise(function (res) {
      var logo = img.hasAttribute('data-tu-logo-src');
      function done() { if (!logo) img.classList.add('is-loaded'); res(); }   // A18: stops that image's shimmer
      img.addEventListener('load', function () { if (img.naturalWidth > 1 || logo) done(); }, { once: true }); img.addEventListener('error', done, { once: true });
      // 2026-10-06: <picture> art direction (axis banners', hero tiles' phone crops): the <source>s carry data-tu-srcset too.
      if (img.parentNode && img.parentNode.tagName === 'PICTURE') [].forEach.call(img.parentNode.querySelectorAll('source[data-tu-srcset]'), function (s) { s.srcset = s.getAttribute('data-tu-srcset'); s.removeAttribute('data-tu-srcset'); });
      var ss = logo ? img.getAttribute('data-tu-logo-srcset') : img.dataset.tuSrcset, sr = logo ? img.getAttribute('data-tu-logo-src') : img.dataset.tuSrc;
      if (ss) img.srcset = ss;
      img.src = sr;
      if (logo) { img.removeAttribute('data-tu-logo-src'); img.removeAttribute('data-tu-logo-srcset'); } else { delete img.dataset.tuSrc; delete img.dataset.tuSrcset; }
    });
  }
  function settle(list, ms) { return Promise.race([Promise.all(list), new Promise(function (res) { setTimeout(res, ms); })]); }
  // Video posters below the fold (departments): the poster is set from data-tu-poster when the section's turn comes.
  function fillPoster(v) {
    return new Promise(function (res) {
      var u = v.getAttribute('data-tu-poster'); v.removeAttribute('data-tu-poster');
      var im = new Image(); im.onload = im.onerror = function () { res(); }; im.src = u; v.poster = u;
    });
  }
  function loadBand(band) {
    band.classList.add('is-filling');   // A18: shimmer while this band is the one being filled
    var waits = Array.prototype.slice.call(band.querySelectorAll('img[data-tu-src], img[data-tu-logo-src]')).map(fill)
      .concat(Array.prototype.slice.call(band.querySelectorAll('video[data-tu-poster]')).map(fillPoster));
    band.dispatchEvent(new CustomEvent('tu:band-load', { bubbles: true }));   // lets tu-video's second rail, promos etc. start their own media
    return settle(waits, 2000);
  }
  function next() {
    if (running || !pending.length) return;
    pending.sort(function (a, b) { return distance(a) - distance(b); });
    var band = pending.shift(); running = true;
    loadBand(band).then(function () { band.classList.remove('is-filling'); running = false; next(); });
  }
  function start() { if (started) return; started = true; next(); }
  window.addEventListener('scroll', function () { if (started && !running) next(); }, { passive: true });

  // Hand-off chain. Any link missing (no hero tile, no reviews rail) falls through.
  function afterHero() {
    var rail = document.querySelector('[data-tu-trv]');
    if (!rail) return start();
    var done = false; function go() { if (!done) { done = true; start(); } }
    if (rail.dataset.tuReviewsReady) return go();   // fired before we listened (slow hero, fast rail)
    rail.addEventListener('tu:reviews-ready', go, { once: true });
    setTimeout(go, 4000);                       // players slow or blocked: do not starve the page
  }
  var heroTile = document.querySelector('[data-tu-hero]');
  if (!heroTile) {
    afterHero();
  } else {
    // A5: the main tile is now a real <img class="tu-hM__bg"> (was a CSS
    // background-image, which this probe used to read via getComputedStyle).
    // Prefer the img's currentSrc (the candidate the browser actually picked
    // from its srcset); fall back to the old background-image read for the
    // two small tiles / any tile still rendered without an <img>.
    var heroImg = heroTile.querySelector('.tu-hM__bg');
    var heroUrl = heroImg && (heroImg.currentSrc || heroImg.src);
    if (!heroUrl) {
      var url = getComputedStyle(heroTile).backgroundImage;
      var m = /url\(["']?([^"')]+)["']?\)/.exec(url);
      heroUrl = m && m[1];
    }
    if (!heroUrl) {
      afterHero();
    } else {
      // Audit fix 2026-09-14: the signal is the hero preload's own onload
      // (tu-hero-mosaic.liquid sets data-tu-hero-loaded on <html> and fires
      // tu:hero-loaded). A bare Image() probe re-downloaded the hero when the
      // cache was disabled and the blur outlived the real image. The probe
      // stays only as a 6 s fallback for a browser that never fires the
      // preload's load event.
      var signalled = false;
      function heroDone() {
        if (signalled) return; signalled = true; heroTile.classList.add('is-hero-loaded');
        // 2026-10-06: the two small tiles come next, right after the main hero and before the reviews rail and everything below.
        var tiles = Array.prototype.slice.call(heroTile.querySelectorAll('img[data-tu-src]')).map(fill);
        settle(tiles, 2500).then(function () { document.documentElement.setAttribute('data-tu-tiles-loaded', '1'); document.dispatchEvent(new CustomEvent('tu:tiles-loaded')); afterHero(); });
      }   // A18: fades out the LQIP
      if (document.documentElement.hasAttribute('data-tu-hero-loaded')) heroDone();
      else {
        document.addEventListener('tu:hero-loaded', heroDone, { once: true });
        setTimeout(function () { if (signalled) return; var probe = new Image(); probe.addEventListener('load', heroDone, { once: true }); probe.addEventListener('error', heroDone, { once: true }); probe.src = heroUrl; }, 6000);
      }
    }
  }
})();
